module.exports = __webpack_public_path__ + "static/media/accSelectedMgr.036aa10d.svg";